import {
  GoArrowUpRight,
  GoArrowRight,
  GoArrowLeft,
  GoArrowUpLeft,
} from "react-icons/go";
import { Button, Box } from "@mui/material";
import { sendWhatsappMessage } from "../../../../shared/helpers/MessageHelper";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

export const HomeSectionButtons = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        mb: "1rem",
        display: "flex",
        flexWrap: { xs: "wrap" },
        justifyContent: "center",
        gap: { xs: "0.5rem", sm: "1rem" }, // Adjust gap for small screens
      }}
    >
      <Button
        onClick={() =>
          sendWhatsappMessage("Hello, I would like to get in touch.")
        }
        variant="contained"
        sx={{
          backgroundColor: "#1b1b1b",
          color: "white",
          fontFamily: i18next.language === "ar" ? "Somar" : "DM Sans",
          fontSize: { xs: ".9rem", sm: "1.2rem", md: "1.5rem" },
          height: { xs: "3rem", sm: "4rem", md: "5rem" },
          padding: { xs: "0 1.5rem", sm: "0 2.5rem", md: "0 3.5rem" },
          display: "flex",
          alignItems: "center",
          borderRadius: "0",
          textTransform: "none",
          gap: "1rem",
        }}
      >
        {t("get_started")}
        {i18next.language === "en" ? <GoArrowUpRight /> : <GoArrowUpLeft />}
      </Button>

      <Button
        onClick={() => {
          const element = document.getElementById("servicesSection");
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }}
        variant="outlined"
        sx={{
          borderColor: "#e3e3e3",
          borderRadius: "0",
          color: "black",
          backgroundColor: "white",
          fontFamily: i18next.language === "ar" ? "Somar" : "DM Sans",
          fontSize: { xs: ".9rem", sm: "1.2rem", md: "1.5rem" },
          height: { xs: "3rem", sm: "4rem", md: "5rem" },
          padding: { xs: "0 1.5rem", sm: "0 2.5rem", md: "0 3.5rem" },
          display: "flex",
          alignItems: "center",
          gap: "1rem",
          textTransform: "none",
        }}
      >
        {t("learn_more")}
        {i18next.language === "en" ? <GoArrowRight /> : <GoArrowLeft />}
      </Button>
    </Box>
  );
};
